export default {
  priceHigher: {
    id: 'cart_replace_higher_comment',
    defaultMessage: 'Same device from another seller.',
  },
  priceLower: {
    id: 'cart_replace_lower_comment',
    defaultMessage: 'The price has dropped. Lucky you!',
  },
  // Copied from Description.translations.ts
  productGrade: {
    id: 'product_grade',
    defaultMessage: 'Esthetic condition:',
  },
  // Copied from Description.translations.ts
  productGradeWithNewBattery: {
    id: 'product_grade_with_new_battery',
    defaultMessage: '{grade} with new battery',
  },
  // Copied from PriceBlock.vue
  bundlingDiscount: {
    id: 'funnel_cart_bundle_discount',
    defaultMessage: 'Bundling saved you {price}',
  },
}
